import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GiniusWordmark } from "./GiniusWordmark";

// Splash brandizzata mostrata all'avvio (una volta per sessione / ad ogni apertura della PWA installata).
export function SplashScreen() {
  const [show, setShow] = useState(() => {
    try { return !sessionStorage.getItem("ginius_splash"); } catch (_) { return true; }
  });

  useEffect(() => {
    if (!show) return;
    try { sessionStorage.setItem("ginius_splash", "1"); } catch (_) {}
    const t = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.55 }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
          style={{ background: "radial-gradient(circle at 50% 35%, #8E2049 0%, #7A193D 55%, #5C112C 100%)" }}
        >
          <motion.span
            className="mb-6 inline-block w-28 h-28 rounded-3xl shadow-2xl ring-2 ring-[#D4AF5A]/60 relative"
            initial={{ scale: 0.7, opacity: 0, y: 8, rotateY: 0 }}
            animate={{ scale: 1, opacity: 1, y: 0, rotateY: 360 }}
            transition={{
              scale: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
              opacity: { duration: 0.6 },
              y: { duration: 0.6 },
              rotateY: { duration: 1.4, ease: [0.4, 0, 0.2, 1], delay: 0.15 },
            }}
            style={{ transformStyle: "preserve-3d", perspective: "600px" }}
          >
            <img src="/ginius-emblem.png" alt="Ginius"
                 className="w-28 h-28 rounded-3xl object-contain"
                 style={{ transform: "translateZ(6px)", backfaceVisibility: "hidden" }} />
            {/* Retro-moneta: G bianca su sfondo bordeaux · Iter122ev: G più grande (text-7xl senza clamp) */}
            <span aria-hidden="true" className="absolute inset-0 rounded-3xl flex items-center justify-center text-7xl font-black italic text-white"
                  style={{
                    background: "#78072D",
                    fontFamily: 'Georgia, "Times New Roman", serif',
                    transform: "translateZ(-8px) rotateY(180deg)",
                    backfaceVisibility: "hidden",
                  }}>G</span>
          </motion.span>
          <GiniusWordmark className="text-6xl text-white" dot />
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.85, duration: 0.5 }}
            className="mt-3 font-brand italic text-[#F0C9D6] text-lg"
          >
            Tu lo chiedi, lui lo fa!
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
